import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "validation": "web_ui__Validation__validation",
  "primary": "web_ui__Validation__primary",
  "amplified": "web_ui__Validation__amplified",
  "muted": "web_ui__Validation__muted",
  "success": "web_ui__Validation__success",
  "warning": "web_ui__Validation__warning",
  "inverse": "web_ui__Validation__inverse"
};

var VALIDATION_THEME_VALUES = ['primary', 'amplified', 'muted', 'success', 'warning', 'inverse'];
/* ---------- Back-compat shim (deprecated) ---------- */
var VALIDATION_THEME = {
  Primary: 'primary',
  Amplified: 'amplified',
  Muted: 'muted',
  Success: 'success',
  Warning: 'warning',
  Inverse: 'inverse'
};
var cssClasses = classNames.bind(styles);
var ValidationBase = function ValidationBase(_ref) {
  var text = _ref.text,
    theme = _ref.theme,
    testId = _ref.testId;
  var validationClass = cssClasses('validation', theme);
  return /*#__PURE__*/jsx("div", {
    className: validationClass,
    "data-testid": testId,
    role: "alert",
    children: text
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Validation = _Object$assign(ValidationBase, {
  /** @deprecated Use string literals, e.g. theme="success" */
  Theme: VALIDATION_THEME
});

export { VALIDATION_THEME, VALIDATION_THEME_VALUES, Validation, Validation as default };
//# sourceMappingURL=Validation.js.map
